import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=2b31a50e&scoped=true"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=2b31a50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31a50e",
  null
  
)

export default component.exports